import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '../store';
import { TextTemplateDto } from '@/models/TextTemplateDto';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';

export class TextTemplateService {
    private client: QuestelServicesClient;

    constructor() {
      this.client = new QuestelServicesClient(store, '');
    }

    public async getTextTemplate(type: TextTemplateTypeEnum | string): Promise<TextTemplateDto[]> {
      return await this.client.get(`/api/texttemplate?textTemplateType=${type}`);
    }

    public async getAvailableAutoText(textTemplateType: TextTemplateTypeEnum | string): Promise<string[]> {
      return await this.client.get(`/api/texttemplate/available-auto-texts?textTemplateType=${textTemplateType}`);
    }

    public async insertTextTemplate(data: TextTemplateDto): Promise<any> {
      return await this.client.postJson(`/api/texttemplate`, data);
    }

    public async updateTextTemplate(data: TextTemplateDto): Promise<any> {
      return await this.client.putJson(`/api/texttemplate`, data);
    }

    public async checkIfExists(name: string, textTemplateType?: TextTemplateTypeEnum): Promise<RequestResult<boolean>> {
      const query = `/api/texttemplate/check-if-exist?name=${name}&textTemplateType=${textTemplateType}`;
      return await this.client.getJson<boolean>(query);
    }

    public async getTextTemplateById(id: Guid): Promise<TextTemplateDto> {
       return await this.client.get(`/api/texttemplate/${id}`);
    }
}
